import { Directive, computed, inject, input, output } from '@angular/core';
import { TimerService } from '@app/core/services';
import { WidgetLocation } from '@app/features/operating-picture/map-wall-display/models';

@Directive()
export abstract class LocationWidgetCard<T> {
  protected timer = inject(TimerService);
  settings = input.required<T>();
  location = input.required<WidgetLocation>();
  canEdit = input<boolean>(false);
  isEditing = false;
  isSelected = input<boolean>(false);
  isDragging = input<boolean>(false);
  onClick = output();
  confirmRemove = false;
  onRemove = output();
  onNameChange = output<string>();
  onSetLocationFromMap = output();
}
